/**
 * 🎯 Performance-Optimized Logger
 * 
 * Logs nur in Development Mode - in Production bleibt Console clean
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
    /**
     * Development-only logging
     * Wird in Production komplett ignoriert
     */
    dev: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },
    
    /**
     * Warning logs (immer anzeigen)
     */
    warn: (...args) => {
        console.warn(...args);
    },
    
    /**
     * Error logs (immer anzeigen)
     */
    error: (...args) => {
        console.error(...args);
    },
    
    /**
     * Info logs (nur Development)
     */
    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },
    
    /**
     * Performance Timing (nur Development)
     * Misst wie lange eine Operation dauert
     * 
     * Usage:
     * logger.time('Widget Render');
     * // ... code ...
     * logger.timeEnd('Widget Render');
     */
    time: (label) => {
        if (isDevelopment) {
            console.time(label);
        }
    },
    
    timeEnd: (label) => {
        if (isDevelopment) {
            console.timeEnd(label);
        }
    },
    
    /**
     * Group logs zusammen (nur Development)
     */
    group: (label) => {
        if (isDevelopment) {
            console.group(label);
        }
    },
    
    groupEnd: () => {
        if (isDevelopment) {
            console.groupEnd();
        }
    },
    
    /**
     * Table display (nur Development)
     */
    table: (data) => {
        if (isDevelopment) {
            console.table(data);
        }
    }
};

/**
 * Performance Wrapper
 * Führt eine Funktion aus und misst die Performance
 * 
 * Usage:
 * const result = logger.perf('My Operation', () => {
 *     return someExpensiveOperation();
 * });
 */
logger.perf = (label, fn) => {
    if (isDevelopment) {
        logger.time(label);
        const result = fn();
        logger.timeEnd(label);
        return result;
    }
    return fn();
};

export default logger;

